import { render, staticRenderFns } from "./XrUpgradeDialog.vue?vue&type=template&id=35d1ca3b&"
import script from "./XrUpgradeDialog.vue?vue&type=script&lang=js&"
export * from "./XrUpgradeDialog.vue?vue&type=script&lang=js&"
import style0 from "./XrUpgradeDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "XrUpgradeDialog.vue"
export default component.exports